module.exports = __webpack_public_path__ + "static/mastodon-7b583a6fe1a96e8aa9b816b8f8a25a3f.png";